import styled from "styled-components";

export default styled.h3`
  font-size: 0.875rem;
  color: #5e6c84;
`;
